module.exports = __webpack_public_path__ + "img/99.55b47bfb.jpg";